import React from "react";
import { Component } from "react";
import linkedin from "views/ilearn/ilearndetails/img/linkedin.png"; 
import Certificate from "views/ilearn/ilearndetails/img/award.png";
class EnrollmentOptions extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="my-10">
        <div className="flex">
          <div className="w-3/5	">       <div> <h1 className="text-black fsize28 font-bold">ENROLLMENT OPTIONS</h1>

        <div class="flex justify-start items-center lg:mt-4 md:mt-4">
          <div className="flex items-center">
            <div class="flex items-center mr-2">
              <p class="fsize18 text-black font-semibold">
                Start learning Today
              </p>
            </div>

            <div class="flex items-center">
              <span class="dot-point bg-E77817 rounded-full mx-2"></span>
              <p class="fsize18 text053C6D font-semibold">
                Financial Aid available
              </p>
            </div>
          </div>

          <div className="ml-12">
            <button className="uppercase  fsize16 font-bold w-200px h-50px rounded-25px filled-button">
              Enroll for free
            </button>
          </div>
        </div>
        <div className="mt-6">
          <div className="flex items-center">
            <p className="text-black font-semibold ">Shareable on</p>
            <img src={linkedin} alt="linkedin" className="w-6 h-6 ml-2" />
          </div>
          <p className="text707070 fsize16 line-h24 w-3/5 mt-4" >
            You can share your Course Certificates in the Certifications section
            of your LinkedIn profile, on printed resumes, CVs, or other
            documents.
          </p>
        </div></div></div>
          <div className="w-2/5	">
          
          <div>
          <img src={Certificate} alt="Certificate" className="w-272px h-209px m-auto" />
          </div>
          
          </div>
        </div>

 
       
      </div>
    );
  }
}
export default EnrollmentOptions;
